import { FC, PropsWithChildren, useContext, useMemo, useState } from 'react';
import LinkedinLogsConversationModal from './LinkedinLogsConversationModal';
import { useAuth } from 'context/auth';
import { LinkedinLogsConversationModalProps } from './types';
import { CloseMdIcon, IconButton } from '@crono-one/design-system';
import { LinkedinLogsConversationContext } from './contexts';

const LinkedinLogsConversationProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const { user } = useAuth();
  const [linkedinLogsConversationContent, setLinkedinLogsConversationContent] =
    useState<LinkedinLogsConversationModalProps | null>(null);
  //If there is no user I prevent the window from opening
  const open = useMemo(() => {
    if (!user) return undefined;
    return !!linkedinLogsConversationContent;
  }, [user, linkedinLogsConversationContent]);
  //There are some cases in which this is opened from another provided that is not accessible from here, so to close it on redirect we need to set the function when opening this
  const [closeToRedirectInboxFunction, setCloseToRedirectInboxFunction] =
    useState<(() => void) | undefined>(() => {});
  return (
    <LinkedinLogsConversationContext.Provider
      value={{
        setLinkedinLogConversationContent: setLinkedinLogsConversationContent,
        linkedinLogsConversationContent: linkedinLogsConversationContent,
        setCloseToRedirectInboxFunction,
      }}
    >
      {open && linkedinLogsConversationContent?.prospect && (
        <div
          className="email-thread-container"
          style={{
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 16,
            }}
          >
            <IconButton
              variant="light"
              tone="lightGray"
              size="lg"
              label="Close drawer"
              icon={CloseMdIcon}
              shape="rounded"
              onClick={() => setLinkedinLogsConversationContent(null)}
            />
            <p className="text-2xl font-bold">LinkedIn chat</p>
          </div>
          <LinkedinLogsConversationModal
            prospect={linkedinLogsConversationContent.prospect}
            close={() => setLinkedinLogsConversationContent(null)}
            onRedirectToInbox={closeToRedirectInboxFunction}
          />
        </div>
      )}
      {children}
    </LinkedinLogsConversationContext.Provider>
  );
};

export function useLinkedinLogsConversationContext() {
  const context = useContext(LinkedinLogsConversationContext);
  if (context === undefined) {
    throw new Error(
      `useLinkedinLogsConversationContext must be used within a LinkedinLogsConversationProvider`,
    );
  }

  return context;
}

export default LinkedinLogsConversationProvider;
